import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragModalComponent } from './modal-draggable.component';
import { DragModalService } from './modal-draggable.service';

@NgModule({
  declarations: [
    DragModalComponent
  ],
  exports: [
    DragModalComponent
  ],
  imports: [
    CommonModule
  ],
  //providers: [
  //  DragModalService
  //]
})

export class DragModalModule { }
